<div class="page">
  <ngx-loading [show]="showSpinner"></ngx-loading>

  <div class="page-content">
    <div class="table-top">
      <div class="section-header">Reenvío de Invitación</div>
    </div>

    <div class="search-bar mb-4">
      <div class="input-group">
        <input
          type="text"
          class="form-control"
          placeholder="Buscar por nombre, email, ID Sintra o DID"
          [(ngModel)]="searchTerm"
          (keyup.enter)="onSearch()"
        />
        <div class="input-group-append">
          <button class="btn btn-primary" (click)="onSearch()">
            <i class="fa fa-search"></i> Buscar
          </button>
        </div>
      </div>
    </div>

    <div class="table-body">
      <div *ngIf="loadError && !showSpinner" class="alert alert-danger">
        Error al cargar las invitaciones. Por favor recargá la página.
      </div>

      <div *ngIf="pagedResults && pagedResults.items.length === 0 && !showSpinner" class="alert alert-info">
        No se encontraron usuarios para el término ingresado.
      </div>

      <table class="table table-striped table-bordered" *ngIf="pagedResults && pagedResults.items.length > 0">
        <thead>
          <tr class="table-names">
            <th>Nombre y Apellido</th>
            <th>Email</th>
            <th>ID Sintra</th>
            <th>Estado de Credencial</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let result of pagedResults.items">
            <td>{{ result.fullName }}</td>
            <td>{{ result.email }}</td>
            <td>{{ result.sintraId }}</td>
            <td>
              <span
                class="badge"
                [ngClass]="{
                  'badge-warning': result.credentialStatus === 'pendiente',
                  'badge-success': result.credentialStatus === 'emitida',
                  'badge-danger':  result.credentialStatus === 'revocada'
                }"
              >
                {{ result.credentialStatus }}
              </span>
            </td>
            <td class="text-center">
              <button
                class="btn btn-sm btn-outline-primary"
                [disabled]="!canResend(result)"
                [title]="resendTooltip(result)"
                (click)="confirmResend(result)"
              >
                <i class="fa fa-paper-plane"></i> Reenviar invitación
              </button>
            </td>
          </tr>
        </tbody>
      </table>

      <app-pagination
        *ngIf="pagedResults"
        [options]="options"
        [pagedList]="$any(pagedResults)"
        [callback]="loadData"
      ></app-pagination>
    </div>
  </div>
</div>
